module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"SiteTitle":"LightFileシミュレータ","SiteTitleSub":"・画像軽量化の可能性を無料レポート","NewReport":"新しいレポートを作成","RecentReports":"最近見たレポート","ProductName":"LightFile","ProductLink":"https://www.ideamans.com/lp1/lightfile-bot/"}}')
  delete Component.options._Ctor
}
